import { Reveal, Overline } from "../Reveal";
import { MIST_IMAGE } from "../../data/modules";
import { useI18n } from "../../i18n/I18nContext";

const CHAPTERS = [
  {
    n: "01", title: "Vision",
    quote: "Sans Vision, l'Autorité ne peut entraîner les hommes vers la Vertu agissante.",
    text: "Tout commence par une vision. Nous aidons chacun à voir loin, à voir juste — à dessiner la trajectoire qui lui ressemble avant de courir.",
  },
  {
    n: "02", title: "Autorité",
    quote: "L'autorité qui entraîne n'est jamais imposée : elle rayonne.",
    text: "La vraie autorité naît de la clarté intérieure. Elle inspire la confiance, fédère les équipes et donne du poids à chaque décision.",
  },
  {
    n: "03", title: "Vertu",
    quote: "Sans Vertu, l'Audace d'une entreprise ne peut développer la Vie.",
    text: "La vertu agissante est notre boussole : l'exigence éthique qui transforme l'ambition en réussite durable, pour soi comme pour les autres.",
  },
  {
    n: "04", title: "Audace",
    quote: "L'audace est le courage d'agir juste.",
    text: "Oser nommer, oser bouger, oser choisir. Nous cultivons cette audace mesurée qui fait basculer les carrières — et les vies.",
  },
  {
    n: "05", title: "Vie",
    quote: "La retraite n'est pas une fin : c'est l'épanouissement de la vie dans sa plus grande maturité.",
    text: "La vraie vie couronne le parcours. Transmettre, mentorner, rayonner : nous l'accompagnons avec la même exigence que le premier emploi.",
  },
];

export const Manifesto = () => {
  const { t } = useI18n();
  return (
  <section id="manifeste" data-testid="manifesto-section" className="relative py-28 md:py-40">
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      <Reveal>
        <Overline>{t("manifesto.overline")}</Overline>
        <h2 className="mt-6 font-serif text-4xl md:text-6xl tracking-tight text-ink max-w-3xl leading-tight">
          {t("manifesto.title")}
        </h2>
      </Reveal>

      <div className="mt-20 md:mt-28">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.n} delay={0.05}>
            <div
              data-testid={`manifesto-chapter-${i}`}
              className={`relative py-14 md:py-20 grid md:grid-cols-12 gap-8 items-start ${i > 0 ? "border-t border-linen" : ""}`}
            >
              <span className="pointer-events-none select-none absolute -top-6 md:-top-10 font-serif text-[7rem] md:text-[11rem] leading-none text-ink/[0.06] left-0">
                {c.n}
              </span>
              <div className="md:col-span-4 relative">
                <h3 className="font-serif text-3xl md:text-5xl tracking-tight text-ink">{c.title}</h3>
              </div>
              <div className="md:col-span-5 relative">
                <p className="font-serif italic text-xl md:text-2xl text-sagedark leading-snug">« {c.quote} »</p>
              </div>
              <div className="md:col-span-3 relative">
                <p className="text-sm md:text-base leading-relaxed text-smoke">{c.text}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal className="mt-20 md:mt-28">
        <div className="relative overflow-hidden rounded-3xl">
          <img src={MIST_IMAGE} alt="Forêt dans la brume de montagne" className="w-full h-[420px] md:h-[560px] object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-ink/50 via-transparent to-transparent" />
          <p className="absolute bottom-8 left-8 md:bottom-12 md:left-12 max-w-lg font-serif text-2xl md:text-4xl text-paper leading-snug">
            Des photos apaisantes, une exigence de force — comme votre parcours.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
  );
};
